import { ordenacioDates } from '../../commons/ordenacio';
import { MASCARA_YYYYMMDD } from '../../commons/gestioDates';
import React from 'react';
import _ from 'lodash';

const renderitzarNomComplet = (registreHistoricObservador) => {
    const { nom, cognom1, cognom2 } = registreHistoricObservador;

    return (<span>{nom} {cognom1} {cognom2}</span>);
};

const configuracioTaula = [
    {
        title: 'Nom',
        key: 'nomComplet',
        render: (text, record) => renderitzarNomComplet(record)
    },
    {
        title: 'Codi',
        dataIndex: 'codi',
        key: 'codi',
        className: 'estacio-taula-historic-observadors-columna-codi',
    },
    {
        title: 'Data d\'alta',
        dataIndex: 'dataAlta',
        key: 'dataAlta',
        className: 'estacio-introduccio-taula-columna-data',
        sorter: (itemA, itemB) => ordenacioDates(itemA.dataAlta, itemB.dataAlta, MASCARA_YYYYMMDD)
    },
    {
        title: 'Data de baixa',
        dataIndex: 'dataBaixa',
        key: 'dataBaixa',
        className: 'estacio-introduccio-taula-columna-data',
        sorter: (itemA, itemB) => ordenacioDates(itemA.dataBaixa, itemB.dataBaixa, MASCARA_YYYYMMDD),
        defaultSortOrder: 'descend'
    }
];

export const columnesTaulaHistoricObservadors = () => (_.cloneDeep(configuracioTaula));



// WEBPACK FOOTER //
// ./src/components/estacio/configuracioTaulaHistoricObservadors.js